import Typography from "@mui/material/Typography";
import CTrackerTimelineItem from "components/CTimelineItem";
import useTracker from "components/CTracker/useTrackerContext";
import { Fragment } from "react";
import { useTheme } from "@mui/material";
import { TrackerStatusColor } from "typedef/TrackerStatusColor";

const TitleVerification: React.FC<{
  trackerStatusColor: TrackerStatusColor;
}> = ({ trackerStatusColor }) => {
  const theme = useTheme();
  const { loan } = useTracker();
  const borrowerSteps = loan?.borrowerSteps;
  const prevStep =
    borrowerSteps?.scheduleClosingVerification.status === "success";
  const status = prevStep
    ? borrowerSteps?.titleVerification?.status ?? "pending"
    : "pending";
  const message = borrowerSteps?.titleVerification?.message ?? "";
  const data = borrowerSteps?.titleVerification?.data;

  return (
    <Fragment>
      <CTrackerTimelineItem
        status={status}
        title="Title"
        tooltip="Title review is our final step prior to finalizing your loan documents."
      >
        {status === "failed" && data && (
          <Typography variant="h6" color={theme.palette.text.primary}>
            {message}
          </Typography>
        )}
        <Typography variant="h6" color={[trackerStatusColor[status]]}>
          {status === "analyzing" && (message || "Analyzing")}{" "}
          {status === "failed" && !data && message}
          {status === "failed" && data && data}
          {status === "success" && message}
        </Typography>
      </CTrackerTimelineItem>
    </Fragment>
  );
};

export default TitleVerification;
